export const SETADDRESS = "SETADDRESS";
export const SAVEPRICE = "SAVEPRICE";

export const LOGINSUCCESS = "LOGINSUCCESS";
export const SAVEChainId = "SAVEChainId";
export const SAVEisSelectAll = "SAVEisSelectAll";
//登录成功接口
export interface loginSuccess {
  type: typeof LOGINSUCCESS;
  value: {
    address: string;
    token: string;
  };
}
//创建登录成功Action
export const createLoginSuccessAction = (
  address: string,
  token: string
): loginSuccess => ({
  type: LOGINSUCCESS,
  value: {
    address,
    token,
  },
});
//保存price Action
export const savePriceAction = (price: string): savePrice => ({
  type: SAVEPRICE,
  value: price,
});
//保存chainId
export const saveSelectAll = (price: any): any => ({
  type: SAVEisSelectAll,
  value: price,
});
//保存chainId
export const saveChainId = (price: any): any => ({
  type: SAVEChainId,
  value: price,
});

//添加全局提醒
export const ADDMESSAGE = "ADDMESSAGE";
export const BEFOREADDMESSAGE = "BEFOREADDMESSAGE";
export interface message {
  message: string;
  index: number;
}
export interface beforeAddMessage {
  type: typeof BEFOREADDMESSAGE;
  value: message;
}
export interface addMessage {
  type: typeof ADDMESSAGE;
  value: message;
}
export interface savePrice {
  type: typeof SAVEPRICE;
  value: string;
}
export interface saveChainId {
  type: any;
  value: any;
}
export interface saveSelectAll {
  type: any;
  value: any;
}


//创建全局提醒Action
export const createAddMessageAction = (message: message): beforeAddMessage => ({
  type: BEFOREADDMESSAGE,
  value: message,
});

//删除全局提醒
export const DELMESSAGE = "DELMESSAGE";
export interface delMessage {
  type: typeof DELMESSAGE;
  value: number;
}
//创建删除全局提醒Action
export const createDelMessageAction = (index: number): delMessage => ({
  type: DELMESSAGE,
  value: index,
});
//是否显示LODING
export const SETLODING = "SETLODING";
export interface setLodingAction {
  type: typeof SETLODING;
  value: Boolean;
}
//创建删除全局提醒Action
export const createSetLodingAction = (
  showLoding: Boolean
): setLodingAction => ({
  type: SETLODING,
  value: showLoding,
});
//reducer参数汇总
export type reducerParameterType =
  | loginSuccess
  | beforeAddMessage
  | addMessage
  | delMessage
  | setLodingAction
  | savePrice|saveChainId
  | saveSelectAll;
